import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Smartphone, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
interface StepConnectProps {
  onNext: (phone: string) => void;
}
export function StepConnect({
  onNext
}: StepConnectProps) {
  const [phone, setPhone] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      onNext(phone);
    }, 1000);
  };
  return <div className="space-y-6" data-id="element-481">
      <div className="text-center space-y-2" data-id="element-482">
        <div className="mx-auto w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4" data-id="element-483">
          <Smartphone className="w-8 h-8 text-[#4f1964]" data-id="element-484" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-485">Connect WhatsApp</h2>
        <p className="text-gray-500" data-id="element-486">Enter your phone number to get started</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5 mt-8" data-id="element-487">
        <Input label="Phone Number (with country code)" type="tel" placeholder="+1 (555) 000-0000" value={phone} onChange={e => setPhone(e.target.value)} required data-id="element-488" />

        <Button type="submit" variant="primary" fullWidth isLoading={isLoading} data-id="element-489">
          Continue <ArrowRight className="ml-2 w-5 h-5" data-id="element-490" />
        </Button>

        <p className="text-xs text-gray-500 text-center" data-id="element-491">
          By continuing, you agree to our Terms of Service and Privacy Policy.
        </p>
      </form>
    </div>;
}